export const getCalculatedHeight = (ref: React.RefObject<HTMLDivElement>) =>{
    if (ref?.current?.getElementsByTagName('p')?.[0]?.textContent) {
        const height = ref.current.offsetHeight;
        const newHeight = (height + 32);
        return (newHeight);
    }
}